/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
import { APIGatewayClient, Utils, uritemplate } from 'aws-api-client'
import { secureStorage_getItem } from '../utility/secureStorage';

var apigClientFactory = {};
apigClientFactory.newClient = function (config) {
    var apigClient = {};
    if (config === undefined) {
        config = {
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            region: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
    }
    if (config.accessKey === undefined) {
        config.accessKey = '';
    }
    if (config.secretKey === undefined) {
        config.secretKey = '';
    }
    if (config.apiKey === undefined) {
        config.apiKey = '';
    }
    if (config.sessionToken === undefined) {
        config.sessionToken = '';
    }
    if (config.region === undefined) {
        config.region = 'us-east-1';
    }
    //If defaultContentType is not defined then default to application/json
    if (config.defaultContentType === undefined) {
        config.defaultContentType = 'application/json';
    }
    //If defaultAcceptType is not defined then default to application/json
    if (config.defaultAcceptType === undefined) {
        config.defaultAcceptType = 'application/json';
    }


    // extract endpoint and path from url
    var invokeUrl = 'https://86e346vz60.execute-api.us-east-1.amazonaws.com/api';
    var endpoint = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
        accessKey: config.accessKey,
        secretKey: config.secretKey,
        sessionToken: config.sessionToken,
        serviceName: 'execute-api',
        region: config.region,
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var authType = 'NONE';
    if (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '') {
        authType = 'AWS_IAM';
    }

    var simpleHttpClientConfig = {
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var apiGatewayClient = new APIGatewayClient(simpleHttpClientConfig, sigV4ClientConfig);
    var utils = new Utils();



    apigClient.rootGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var rootGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(rootGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.rootOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var rootOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(rootOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.amazonAuthCallbackPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var amazonAuthCallbackPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/amazon/auth/callback').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(amazonAuthCallbackPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.amazonAuthCallbackOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var amazonAuthCallbackOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/amazon/auth/callback').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(amazonAuthCallbackOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.amazonAuthInitPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var amazonAuthInitPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/amazon/auth/init').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(amazonAuthInitPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.amazonAuthInitOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var amazonAuthInitOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/amazon/auth/init').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(amazonAuthInitOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsCompressFilesPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsCompressFilesPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/compressFiles').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsCompressFilesPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsCompressFilesOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsCompressFilesOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/compressFiles').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsCompressFilesOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsDownloadJsonFilePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsDownloadJsonFilePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/downloadJsonFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsDownloadJsonFilePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsDownloadJsonFileOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsDownloadJsonFileOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/downloadJsonFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsDownloadJsonFileOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsDownloadTsvFilePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsDownloadTsvFilePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/downloadTsvFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsDownloadTsvFilePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsDownloadTsvFileOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsDownloadTsvFileOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/downloadTsvFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsDownloadTsvFileOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGenerateLogPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsGenerateLogPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/generateLog').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGenerateLogPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGenerateLogOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsGenerateLogOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/generateLog').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGenerateLogOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGetCUSTCUIConstantParameterGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['parameter'], ['body']);

        var awsopsGetCUSTCUIConstantParameterGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/getCUSTCUIConstant/{parameter}').expand(utils.parseParametersToObject(params, ['parameter'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGetCUSTCUIConstantParameterGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGetCUSTCUIConstantParameterOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['parameter'], ['body']);

        var awsopsGetCUSTCUIConstantParameterOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/getCUSTCUIConstant/{parameter}').expand(utils.parseParametersToObject(params, ['parameter'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGetCUSTCUIConstantParameterOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGetPDFGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsGetPDFGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/getPDF').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGetPDFGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsGetPDFOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsGetPDFOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/getPDF').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsGetPDFOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsPreSignedS3URLPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsPreSignedS3URLPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/preSignedS3URL').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsPreSignedS3URLPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsPreSignedS3URLOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsPreSignedS3URLOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/preSignedS3URL').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsPreSignedS3URLOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileListPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileListPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileListPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileListOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileListOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileListOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileList2Put = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileList2PutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileList2PutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileList2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileList2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileList2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileList3Put = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileList3PutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList3').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileList3PutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketFileList3Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketFileList3OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketFileList3').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketFileList3OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketSearchFilePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketSearchFilePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketSearchFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketSearchFilePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketSearchFileOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketSearchFileOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketSearchFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketSearchFileOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketSubFoldersPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketSubFoldersPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketSubFolders').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketSubFoldersPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsS3BucketSubFoldersOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsS3BucketSubFoldersOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/s3BucketSubFolders').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsS3BucketSubFoldersOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsSearchSkuFromFilePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsSearchSkuFromFilePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/searchSkuFromFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsSearchSkuFromFilePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsSearchSkuFromFileOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var awsopsSearchSkuFromFileOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/searchSkuFromFile').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsSearchSkuFromFileOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsSessionFilelistCustomernameWorkflownameSessionidGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['sessionid', 'workflowname', 'customername'], ['body']);

        var awsopsSessionFilelistCustomernameWorkflownameSessionidGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/sessionFilelist/{customername}/{workflowname}/{sessionid}').expand(utils.parseParametersToObject(params, ['sessionid', 'workflowname', 'customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsSessionFilelistCustomernameWorkflownameSessionidGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.awsopsSessionFilelistCustomernameWorkflownameSessionidOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['sessionid', 'workflowname', 'customername'], ['body']);

        var awsopsSessionFilelistCustomernameWorkflownameSessionidOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/awsops/sessionFilelist/{customername}/{workflowname}/{sessionid}').expand(utils.parseParametersToObject(params, ['sessionid', 'workflowname', 'customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(awsopsSessionFilelistCustomernameWorkflownameSessionidOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.cognitoGetRegionCgGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var cognitoGetRegionCgGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/cognito/getRegionCg').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(cognitoGetRegionCgGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.cognitoGetRegionCgOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var cognitoGetRegionCgOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/cognito/getRegionCg').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(cognitoGetRegionCgOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsAuthUrlsGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsAuthUrlsGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/auth-urls').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsAuthUrlsGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsAuthUrlsOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsAuthUrlsOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/auth-urls').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsAuthUrlsOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsEnvironmentGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsEnvironmentGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/environment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsEnvironmentGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsEnvironmentOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsEnvironmentOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/environment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsEnvironmentOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsToggleIntegrationCWSWorkflowNamePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['WorkflowName'], ['body']);

        var configsToggleIntegrationCWSWorkflowNamePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/toggleIntegrationCWS/{WorkflowName}').expand(utils.parseParametersToObject(params, ['WorkflowName'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsToggleIntegrationCWSWorkflowNamePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsToggleIntegrationCWSWorkflowNameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['WorkflowName'], ['body']);

        var configsToggleIntegrationCWSWorkflowNameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/toggleIntegrationCWS/{WorkflowName}').expand(utils.parseParametersToObject(params, ['WorkflowName'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsToggleIntegrationCWSWorkflowNameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsUpdatecrossreferencePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsUpdatecrossreferencePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/updatecrossreference').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsUpdatecrossreferencePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.configsUpdatecrossreferenceOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var configsUpdatecrossreferenceOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/configs/updatecrossreference').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(configsUpdatecrossreferenceOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBillableWorkflowsGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBillableWorkflowsGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/billableWorkflows').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBillableWorkflowsGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBillableWorkflowsOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBillableWorkflowsOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/billableWorkflows').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBillableWorkflowsOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBillableWorkflowsV2Get = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBillableWorkflowsV2GetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/billableWorkflowsV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBillableWorkflowsV2GetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBillableWorkflowsV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBillableWorkflowsV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/billableWorkflowsV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBillableWorkflowsV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBulkupdatewebservicemessagePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBulkupdatewebservicemessagePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/bulkupdatewebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBulkupdatewebservicemessagePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsBulkupdatewebservicemessageOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsBulkupdatewebservicemessageOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/bulkupdatewebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsBulkupdatewebservicemessageOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsDeleteFileFromS3BucketPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsDeleteFileFromS3BucketPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/deleteFileFromS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsDeleteFileFromS3BucketPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsDeleteFileFromS3BucketOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsDeleteFileFromS3BucketOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/deleteFileFromS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsDeleteFileFromS3BucketOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsEmptyFolderInS3BucketPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsEmptyFolderInS3BucketPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/emptyFolderInS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsEmptyFolderInS3BucketPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsEmptyFolderInS3BucketOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsEmptyFolderInS3BucketOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/emptyFolderInS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsEmptyFolderInS3BucketOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetChannelImagesGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetChannelImagesGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getChannelImages').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetChannelImagesGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetChannelImagesOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetChannelImagesOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getChannelImages').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetChannelImagesOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetCrossReferencesGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetCrossReferencesGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getCrossReferences').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetCrossReferencesGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetCrossReferencesOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetCrossReferencesOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getCrossReferences').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetCrossReferencesOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetEnvironmentGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetEnvironmentGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getEnvironment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetEnvironmentGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetEnvironmentOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetEnvironmentOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getEnvironment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetEnvironmentOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetLatestRecordsTablenameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['tablename'], ['body']);

        var dbopsGetLatestRecordsTablenameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getLatestRecords/{tablename}').expand(utils.parseParametersToObject(params, ['tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetLatestRecordsTablenameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetLatestRecordsTablenameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['tablename'], ['body']);

        var dbopsGetLatestRecordsTablenameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getLatestRecords/{tablename}').expand(utils.parseParametersToObject(params, ['tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetLatestRecordsTablenameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetLatestRecordsV2TablenameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['tablename'], ['body']);

        var dbopsGetLatestRecordsV2TablenameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getLatestRecordsV2/{tablename}').expand(utils.parseParametersToObject(params, ['tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetLatestRecordsV2TablenameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetLatestRecordsV2TablenameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['tablename'], ['body']);

        var dbopsGetLatestRecordsV2TablenameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getLatestRecordsV2/{tablename}').expand(utils.parseParametersToObject(params, ['tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetLatestRecordsV2TablenameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetRegionGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetRegionGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getRegion').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetRegionGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetRegionOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsGetRegionOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getRegion').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetRegionOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetUserInfoUsernameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var dbopsGetUserInfoUsernameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getUserInfo/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetUserInfoUsernameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetUserInfoUsernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var dbopsGetUserInfoUsernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getUserInfo/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetUserInfoUsernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetWorkflowNamesCustomerIDGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['CustomerID'], ['body']);

        var dbopsGetWorkflowNamesCustomerIDGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getWorkflowNames/{CustomerID}').expand(utils.parseParametersToObject(params, ['CustomerID'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetWorkflowNamesCustomerIDGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsGetWorkflowNamesCustomerIDOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['CustomerID'], ['body']);

        var dbopsGetWorkflowNamesCustomerIDOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/getWorkflowNames/{CustomerID}').expand(utils.parseParametersToObject(params, ['CustomerID'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsGetWorkflowNamesCustomerIDOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertAmazonMWSCredsPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertAmazonMWSCredsPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertAmazonMWS_Creds').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertAmazonMWSCredsPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertAmazonMWSCredsOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertAmazonMWSCredsOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertAmazonMWS_Creds').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertAmazonMWSCredsOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertLogPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertLogPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertLog').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertLogPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertLogOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertLogOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertLog').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertLogOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertwebservicemessagePost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertwebservicemessagePostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertwebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertwebservicemessagePostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsInsertwebservicemessageOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsInsertwebservicemessageOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/insertwebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsInsertwebservicemessageOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsPreviewPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsPreviewPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/preview').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsPreviewPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsPreviewOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsPreviewOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/preview').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsPreviewOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUpdateTicketsPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUpdateTicketsPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/updateTickets').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUpdateTicketsPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUpdateTicketsOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUpdateTicketsOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/updateTickets').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUpdateTicketsOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUpdatewebservicemessagePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUpdatewebservicemessagePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/updatewebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUpdatewebservicemessagePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUpdatewebservicemessageOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUpdatewebservicemessageOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/updatewebservicemessage').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUpdatewebservicemessageOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUploadFileToS3BucketPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUploadFileToS3BucketPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/uploadFileToS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUploadFileToS3BucketPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsUploadFileToS3BucketOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsUploadFileToS3BucketOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/uploadFileToS3Bucket').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsUploadFileToS3BucketOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsWorkflowActivityGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsWorkflowActivityGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/workflowActivity').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsWorkflowActivityGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsWorkflowActivityOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsWorkflowActivityOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/workflowActivity').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsWorkflowActivityOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsWorkflowActivityV2Get = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsWorkflowActivityV2GetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/workflowActivityV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsWorkflowActivityV2GetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.dbopsWorkflowActivityV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var dbopsWorkflowActivityV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/dbops/workflowActivityV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(dbopsWorkflowActivityV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerCreateParamObjectPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var schedulerCreateParamObjectPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/createParamObject').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerCreateParamObjectPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerCreateParamObjectOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var schedulerCreateParamObjectOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/createParamObject').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerCreateParamObjectOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['executionID', 'workflowID', 'sessionID', 'sflogID', 'stepfnID', 'custID', 'stepfnInput'], ['body']);

        var schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/replayworkflownowid/{sflogID}/{executionID}/{custID}/{sessionID}/{workflowID}/{stepfnID}/{stepfnInput}').expand(utils.parseParametersToObject(params, ['executionID', 'workflowID', 'sessionID', 'sflogID', 'stepfnID', 'custID', 'stepfnInput'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['executionID', 'workflowID', 'sessionID', 'stepfnID', 'sflogID', 'stepfnInput', 'custID'], ['body']);

        var schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/replayworkflownowid/{sflogID}/{executionID}/{custID}/{sessionID}/{workflowID}/{stepfnID}/{stepfnInput}').expand(utils.parseParametersToObject(params, ['executionID', 'workflowID', 'sessionID', 'stepfnID', 'sflogID', 'stepfnInput', 'custID'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerReplayworkflownowidSflogIDExecutionIDCustIDSessionIDWorkflowIDStepfnIDStepfnInputOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerRestageAMZOrderCustomerNameAmzOrderIDGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customerName', 'amzOrderID'], ['body']);

        var schedulerRestageAMZOrderCustomerNameAmzOrderIDGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/restageAMZOrder/{customerName}/{amzOrderID}').expand(utils.parseParametersToObject(params, ['customerName', 'amzOrderID'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerRestageAMZOrderCustomerNameAmzOrderIDGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.schedulerRestageAMZOrderCustomerNameAmzOrderIDOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customerName', 'amzOrderID'], ['body']);

        var schedulerRestageAMZOrderCustomerNameAmzOrderIDOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/scheduler/restageAMZOrder/{customerName}/{amzOrderID}').expand(utils.parseParametersToObject(params, ['customerName', 'amzOrderID'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(schedulerRestageAMZOrderCustomerNameAmzOrderIDOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthRefreshtokenPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthRefreshtokenPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/refreshtoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthRefreshtokenPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthRefreshtokenOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthRefreshtokenOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/refreshtoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthRefreshtokenOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthSigninPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthSigninPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/signin').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthSigninPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthSigninOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthSigninOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/signin').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthSigninOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthSignupPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthSignupPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/signup').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthSignupPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthSignupOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthSignupOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/signup').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthSignupOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthValidateaccesstokenPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthValidateaccesstokenPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/validateaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthValidateaccesstokenPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shopifyvauthValidateaccesstokenOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shopifyvauthValidateaccesstokenOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shopifyvauth/validateaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shopifyvauthValidateaccesstokenOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetLatestRecordsV2TablenameCustomernameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername', 'tablename'], ['body']);

        var shpfyGetLatestRecordsV2TablenameCustomernameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getLatestRecordsV2/{tablename}/{customername}').expand(utils.parseParametersToObject(params, ['customername', 'tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetLatestRecordsV2TablenameCustomernameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetLatestRecordsV2TablenameCustomernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername', 'tablename'], ['body']);

        var shpfyGetLatestRecordsV2TablenameCustomernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getLatestRecordsV2/{tablename}/{customername}').expand(utils.parseParametersToObject(params, ['customername', 'tablename'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetLatestRecordsV2TablenameCustomernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetListOfDTSsCustomernameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername'], ['body']);

        var shpfyGetListOfDTSsCustomernameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getListOfDTSs/{customername}').expand(utils.parseParametersToObject(params, ['customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetListOfDTSsCustomernameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetListOfDTSsCustomernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername'], ['body']);

        var shpfyGetListOfDTSsCustomernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getListOfDTSs/{customername}').expand(utils.parseParametersToObject(params, ['customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetListOfDTSsCustomernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetTimelineDetailsCustomeridIdGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customerid', 'id'], ['body']);

        var shpfyGetTimelineDetailsCustomeridIdGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getTimelineDetails/{customerid}/{id}').expand(utils.parseParametersToObject(params, ['customerid', 'id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetTimelineDetailsCustomeridIdGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyGetTimelineDetailsCustomeridIdOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customerid', 'id'], ['body']);

        var shpfyGetTimelineDetailsCustomeridIdOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/getTimelineDetails/{customerid}/{id}').expand(utils.parseParametersToObject(params, ['customerid', 'id'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyGetTimelineDetailsCustomeridIdOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyUpdateConfigFieldPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyUpdateConfigFieldPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/updateConfigField').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyUpdateConfigFieldPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyUpdateConfigFieldOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyUpdateConfigFieldOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/updateConfigField').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyUpdateConfigFieldOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyUpdateUserAttributesCustomernamePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername'], ['body']);

        var shpfyUpdateUserAttributesCustomernamePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/updateUserAttributes/{customername}').expand(utils.parseParametersToObject(params, ['customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyUpdateUserAttributesCustomernamePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyUpdateUserAttributesCustomernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['customername'], ['body']);

        var shpfyUpdateUserAttributesCustomernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/updateUserAttributes/{customername}').expand(utils.parseParametersToObject(params, ['customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyUpdateUserAttributesCustomernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyValidateSecretKeyGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyValidateSecretKeyGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/validateSecretKey').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyValidateSecretKeyGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyValidateSecretKeyOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyValidateSecretKeyOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfy/validateSecretKey').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyValidateSecretKeyOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsGetshopifyaccesstokenGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsGetshopifyaccesstokenGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/getshopifyaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsGetshopifyaccesstokenGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsGetshopifyaccesstokenOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsGetshopifyaccesstokenOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/getshopifyaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsGetshopifyaccesstokenOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsShopifyOauthPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsShopifyOauthPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/shopifyOauth').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsShopifyOauthPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsShopifyOauthOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsShopifyOauthOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/shopifyOauth').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsShopifyOauthOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsUpdateshopifyaccesstokenPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsUpdateshopifyaccesstokenPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/updateshopifyaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsUpdateshopifyaccesstokenPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.shpfyauthvalidationsUpdateshopifyaccesstokenOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var shpfyauthvalidationsUpdateshopifyaccesstokenOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/shpfyauthvalidations/updateshopifyaccesstoken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(shpfyauthvalidationsUpdateshopifyaccesstokenOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeAddCardToCustomerPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeAddCardToCustomerPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/addCardToCustomer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeAddCardToCustomerPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeAddCardToCustomerOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeAddCardToCustomerOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/addCardToCustomer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeAddCardToCustomerOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCreateInvoiceItemPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCreateInvoiceItemPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/createInvoiceItem').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCreateInvoiceItemPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCreateInvoiceItemOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCreateInvoiceItemOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/createInvoiceItem').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCreateInvoiceItemOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCreateSubscriptionPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCreateSubscriptionPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/createSubscription').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCreateSubscriptionPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCreateSubscriptionOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCreateSubscriptionOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/createSubscription').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCreateSubscriptionOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerV2Get = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerV2GetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customerV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerV2GetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerV2Post = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerV2PostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customerV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerV2PostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeCustomerV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeCustomerV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/customerV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeCustomerV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakeAPICallPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakeAPICallPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makeAPICall').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakeAPICallPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakeAPICallOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakeAPICallOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makeAPICall').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakeAPICallOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakeAPICallV2Post = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakeAPICallV2PostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makeAPICallV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakeAPICallV2PostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakeAPICallV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakeAPICallV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makeAPICallV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakeAPICallV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakePaymentPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakePaymentPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makePayment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakePaymentPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakePaymentOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakePaymentOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makePayment').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakePaymentOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakePaymentV2Put = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakePaymentV2PutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makePaymentV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakePaymentV2PutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeMakePaymentV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeMakePaymentV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/makePaymentV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeMakePaymentV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeUpdateCustomerPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeUpdateCustomerPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/updateCustomer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeUpdateCustomerPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeUpdateCustomerOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeUpdateCustomerOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/updateCustomer').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeUpdateCustomerOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeUpdateCustomerV2Put = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeUpdateCustomerV2PutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/updateCustomerV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeUpdateCustomerV2PutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeUpdateCustomerV2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeUpdateCustomerV2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/updateCustomerV2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeUpdateCustomerV2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCheckUsernameUsernameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var vlauthCheckUsernameUsernameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/checkUsername/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCheckUsernameUsernameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCheckUsernameUsernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var vlauthCheckUsernameUsernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/checkUsername/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCheckUsernameUsernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCognitocustomattributesUsernameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var vlauthCognitocustomattributesUsernameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/cognitocustomattributes/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCognitocustomattributesUsernameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCognitocustomattributesUsernamePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var vlauthCognitocustomattributesUsernamePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/cognitocustomattributes/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCognitocustomattributesUsernamePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCognitocustomattributesUsernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username'], ['body']);

        var vlauthCognitocustomattributesUsernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/cognitocustomattributes/{username}').expand(utils.parseParametersToObject(params, ['username'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCognitocustomattributesUsernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthConfirmForgotPasswordPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthConfirmForgotPasswordPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/confirmForgotPassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthConfirmForgotPasswordPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthConfirmForgotPasswordOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthConfirmForgotPasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/confirmForgotPassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthConfirmForgotPasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthConfirmUserPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthConfirmUserPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/confirmUser').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthConfirmUserPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthConfirmUserOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthConfirmUserOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/confirmUser').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthConfirmUserOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCustomerBillingInfoGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthCustomerBillingInfoGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/customerBillingInfo').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCustomerBillingInfoGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCustomerBillingInfoPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthCustomerBillingInfoPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/customerBillingInfo').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCustomerBillingInfoPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthCustomerBillingInfoOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthCustomerBillingInfoOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/customerBillingInfo').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthCustomerBillingInfoOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthExchangecodefortokensPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthExchangecodefortokensPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/exchangecodefortokens').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthExchangecodefortokensPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthExchangecodefortokensOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthExchangecodefortokensOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/exchangecodefortokens').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthExchangecodefortokensOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthForgotPasswordPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthForgotPasswordPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/forgotPassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthForgotPasswordPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthForgotPasswordOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthForgotPasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/forgotPassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthForgotPasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthForgotUsernamePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthForgotUsernamePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/forgotUsername').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthForgotUsernamePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthForgotUsernameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthForgotUsernameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/forgotUsername').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthForgotUsernameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthIsUserConfirmedEmailGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['email'], ['body']);

        var vlauthIsUserConfirmedEmailGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/isUserConfirmed/{email}').expand(utils.parseParametersToObject(params, ['email'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthIsUserConfirmedEmailGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthIsUserConfirmedEmailOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['email'], ['body']);

        var vlauthIsUserConfirmedEmailOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/isUserConfirmed/{email}').expand(utils.parseParametersToObject(params, ['email'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthIsUserConfirmedEmailOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthRefreshTokenPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthRefreshTokenPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/refreshToken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthRefreshTokenPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthRefreshTokenOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthRefreshTokenOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/refreshToken').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthRefreshTokenOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthResendConfirmationCodePut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthResendConfirmationCodePutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/resendConfirmationCode').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthResendConfirmationCodePutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthResendConfirmationCodeOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthResendConfirmationCodeOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/resendConfirmationCode').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthResendConfirmationCodeOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSigninUsernamePasswordPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username', 'password'], ['body']);

        var vlauthSigninUsernamePasswordPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signin/{username}/{password}').expand(utils.parseParametersToObject(params, ['username', 'password'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSigninUsernamePasswordPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSigninUsernamePasswordOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username', 'password'], ['body']);

        var vlauthSigninUsernamePasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signin/{username}/{password}').expand(utils.parseParametersToObject(params, ['username', 'password'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSigninUsernamePasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSigninV2UsernamePasswordPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username', 'password'], ['body']);

        var vlauthSigninV2UsernamePasswordPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signinV2/{username}/{password}').expand(utils.parseParametersToObject(params, ['username', 'password'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSigninV2UsernamePasswordPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSigninV2UsernamePasswordOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['username', 'password'], ['body']);

        var vlauthSigninV2UsernamePasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signinV2/{username}/{password}').expand(utils.parseParametersToObject(params, ['username', 'password'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSigninV2UsernamePasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSignupPost = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthSignupPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signup').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSignupPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthSignupOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthSignupOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/signup').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthSignupOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentials').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentials').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsSTSGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsSTSGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentialsSTS').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsSTSGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsSTSOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsSTSOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentialsSTS').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsSTSOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsSTSv2Get = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsSTSv2GetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentialsSTSv2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsSTSv2GetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthTempCredentialsSTSv2Options = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthTempCredentialsSTSv2OptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/tempCredentialsSTSv2').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthTempCredentialsSTSv2OptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthUpdatePasswordPut = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthUpdatePasswordPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/updatePassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthUpdatePasswordPutRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlauthUpdatePasswordOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var vlauthUpdatePasswordOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlauth/updatePassword').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlauthUpdatePasswordOptionsRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlconfigsRetrievelocalparamsCustomernameWorkflownameGet = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['workflowname', 'customername'], ['body']);

        var vlconfigsRetrievelocalparamsCustomernameWorkflownameGetRequest = {
            verb: 'get'.toUpperCase(),
            path: pathComponent + uritemplate('/vlconfigs/retrievelocalparams/{customername}/{workflowname}').expand(utils.parseParametersToObject(params, ['workflowname', 'customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlconfigsRetrievelocalparamsCustomernameWorkflownameGetRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.vlconfigsRetrievelocalparamsCustomernameWorkflownameOptions = function (params, body, additionalParams) {
        if (additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, ['workflowname', 'customername'], ['body']);

        var vlconfigsRetrievelocalparamsCustomernameWorkflownameOptionsRequest = {
            verb: 'options'.toUpperCase(),
            path: pathComponent + uritemplate('/vlconfigs/retrievelocalparams/{customername}/{workflowname}').expand(utils.parseParametersToObject(params, ['workflowname', 'customername'])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(vlconfigsRetrievelocalparamsCustomernameWorkflownameOptionsRequest, authType, additionalParams, config.apiKey);
    };


    return apigClient;
};
export default apigClientFactory;
